module.exports = __webpack_public_path__ + "img/video-cards-cjdr.d103ed07.png";